export const isAuthenticated = (state) => {
  if (state.auth.auth.userName) return true;
  return false;
};
